import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NotifyService } from '../services/notify.service';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private _userS: UserService,
    private route: Router,
    private notify: NotifyService
  ) {}
  token = this._userS.getToken
  canActivate() {
    if (this._userS.getTokenDetails.User_Role === 'DPNF ADMIN' ) {
      console.log(this.token)
      return true
    } else {
      this.notify.error('Unauthorized', 'You are not allowed')
      this.route.navigateByUrl('/login')
      localStorage.clear()
      return false;
    }

  }

}
